import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { buildQuery } from "../../../utils/buildQuery";

export const WorkforceReportsApi = createApi({
  reducerPath: "WorkforceReport",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND2_URL}/v1`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json");
      return headers;
    },
    credentials: "include",
  }),
  endpoints: (builder) => ({
    getProductivityReport: builder.query({
      query: (params) => {
        const query = buildQuery(params);
        return `/tasksReports/fieldStaffProductivity${query}`;
      },
    }),
    getDurationReport: builder.query({
      query: (params) => {
        const query = buildQuery(params);
        console.log("query", query);
        return `/tasksReports/durationEfficiency${query}`;
      },
    }),
    getDurationFile: builder.query({
      async queryFn(arg, _queryApi, _extraOptions, fetchWithBQ) {
        const { val, startDate, endDate } = arg;
        try {
          const result = await fetch(
            `${process.env.REACT_APP_BACKEND2_URL}/v1/tasksReports/durationEfficiency/export?format=${val}&fromDate=${startDate}&toDate=${endDate}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`, // if required
                Accept: "*/*", // let server decide content type (PDF/XLSX)
              },
            }
          );

          if (!result.ok) {
            return {
              error: { status: result.status, data: await result.text() },
            };
          }

          const blob = await result.blob();

          return { data: blob };
        } catch (err) {
          return { error: { status: "FETCH_ERROR", data: err.message } };
        }
      },
    }),
    getProductivityFile: builder.query({
      async queryFn(arg, _queryApi, _extraOptions, fetchWithBQ) {
        const { val, startDate, endDate } = arg;
        try {
          const result = await fetch(
            `${process.env.REACT_APP_BACKEND2_URL}/v1/tasksReports/fieldStaffProductivity/export?format=${val}&fromDate=${startDate}&toDate=${endDate}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`, // if required
                Accept: "*/*", // let server decide content type (PDF/XLSX)
              },
            }
          );

          if (!result.ok) {
            return {
              error: { status: result.status, data: await result.text() },
            };
          }

          const blob = await result.blob();

          return { data: blob };
        } catch (err) {
          return { error: { status: "FETCH_ERROR", data: err.message } };
        }
      },
    }),
    getAttendanceReport: builder.query({
      query: (params) => {
        const query = buildQuery(params);
        return `/attendanceReport${query}`;
      },
    }),
    getDailyAttendanceReport: builder.query({
      query: (params) => {
        const query = buildQuery(params);
        return `/attendanceReport/technicians${query}`;
      },
    }),
    getDailyAttendanceReportFile: builder.query({
      async queryFn(arg, _queryApi, _extraOptions, fetchWithBQ) {
        const { val, startDate, endDate } = arg;
        try {
          const result = await fetch(
            `${process.env.REACT_APP_BACKEND2_URL}/v1/attendanceReport/export?format=${val}&fromDate=${startDate}&toDate=${endDate}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`, // if required
                Accept: "*/*", // let server decide content type (PDF/XLSX)
              },
            }
          );

          if (!result.ok) {
            return {
              error: { status: result.status, data: await result.text() },
            };
          }

          const blob = await result.blob();

          return { data: blob };
        } catch (err) {
          return { error: { status: "FETCH_ERROR", data: err.message } };
        }
      },
    }),
    getAttendanceReportFile: builder.query({
      async queryFn(arg, _queryApi, _extraOptions, fetchWithBQ) {
        const { val, startDate, endDate } = arg;
        try {
          const result = await fetch(
            `${process.env.REACT_APP_BACKEND2_URL}/v1/attendanceReport/export?format=${val}&fromDate=${startDate}&toDate=${endDate}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`, // if required
                Accept: "*/*", // let server decide content type (PDF/XLSX)
              },
            }
          );

          if (!result.ok) {
            return {
              error: { status: result.status, data: await result.text() },
            };
          }

          const blob = await result.blob();

          return { data: blob };
        } catch (err) {
          return { error: { status: "FETCH_ERROR", data: err.message } };
        }
      },
    }),
  }),
});

export const {
  useLazyGetProductivityReportQuery,
  useLazyGetDurationReportQuery,
  useLazyGetDurationFileQuery,
  useLazyGetProductivityFileQuery,
  useLazyGetAttendanceReportQuery,
  useLazyGetAttendanceReportFileQuery,
  useLazyGetDailyAttendanceReportQuery,
  useLazyGetDailyAttendanceReportFileQuery,
} = WorkforceReportsApi;
